import React, {useRef} from 'react';
import styled from 'styled-components';
import { split } from 'lodash';
import * as F from '../../lib/util/CommonFunctions';
import {isMobileOnly} from 'react-device-detect';
import { FormatNumber, showAmount } from '../../lib/util/CommonFunctions';

const ListContainerBlock = styled.div`
    margin: 10px 0;
    border-top: 2px solid #111;

    .pointer {
      cursor: pointer;
  }
`;
const ListBlock = styled.tr`
.product-img {
  border-radius: 4px;
  -ms-interpolation-mode: bicubic;
  object-position: center;
  height: 100px;
  width: 100px;
  vertical-align: middle;
  object-fit: cover;

  
}
.pointer {
  cursor: pointer;
}
`;
const MobileListBlock = styled.div`                
    //margin: 10px 0;
    margin-top:20px;
    border-bottom: 1px solid #ccc;
    .product-thumbnail { 
      width:100px;height:100px; margin-right:10px; 
      
    }
    .prod-name {
        text-overflow: ellipsis;
        overflow: hidden;
        line-height:1.5em;
        height:3em;
        --max-lines:2;
    }
    .opt-qty {
        font-size: 0.9em;
        max-width: 55vw;
     }
    .seller-comment {
        font-size: 0.9em;
        text-overflow:ellipsis; white-space: nowrap; overflow: scroll;
        padding:10px 5px;
        background-color: #ececec;        
        }  
  .quote-item-detail {
    height: 0;
    display: none;
    transition: max-height 3s ease-in;
    border-top: 1px solid #bbb;
    font-size: 0.9em;
    padding: 10px;      
    &.show {
      height: 100%;
      display: block;        
      transition: max-height 3s ease-out;           
    }
  }
`;

const EsComItemList = (props) => {
  // For control slide down detail layers
  const detailLayerRefs = useRef(Array.from({length:props.items.length}, () => React.createRef()));
  const arrowRefs = useRef(Array.from({length:props.items.length}, () => React.createRef()));

  /* 카테고리명가져오기? (코드로 보아 중분류가져오는거 같은데...) */
  const getCateName = (cate_name) => {

    if (cate_name !== null) {
      let catenames = split(cate_name, '>');
      return catenames[1];
    }

    return "";
  }

  /* 착불배송여부 표시 */
  const isCashOnDlvryShow = (item) => {
    if (item.es_detail_dlvry_pay_type === '025202') {
      return { display: 'block' };  // 착불
    } else {
      return { display: 'none' };
    }
  }


  /* 할인율 계산 output */
  const getDscntPercent = (item) => {

    if (item.es_detail_dscnt_per > 0) {
      return (<p><span className="dotted-tag red"><span>{item.es_detail_dscnt_per}</span>%</span></p>);
    } else {
      return ("");
    }
  }

  const toggleDetail = (i) =>{
    detailLayerRefs.current[i].current.classList.toggle('show')

    if(detailLayerRefs.current[i].current.classList.contains('show')){
      arrowRefs.current[i].current.classList.remove("fa-chevron-down");
      arrowRefs.current[i].current.classList.add("fa-chevron-up");
    } else {
      arrowRefs.current[i].current.classList.remove("fa-chevron-up");
      arrowRefs.current[i].current.classList.add("fa-chevron-down");

    }

  }

  const goToProduct = (prdct_id) => {
    let url = "/prod?prodid=" + prdct_id;
    var win = window.open(url, '_blank');
    win.focus();
}

  const getItemsMobile = (items)=>(
    items.map((curitem,i)=>
      <MobileListBlock key={i} className="item-row">
      <div className="flex fs">
        <div className="product-thumbnail" onClick={()=>goToProduct(curitem.prdct_id)}>
          <img src={curitem.repr_img} alt="상품이미지"/>
        </div>
        <div className="flex dcol jsb flex-1">
          <div className="prod-name" onClick={()=>goToProduct(curitem.prdct_id)}>{curitem.prdct_nm}</div>
          <div className="opt-qty" onClick={()=>goToProduct(curitem.prdct_id)}>
            <div className="ellipsis">{curitem.opt_nm}</div>
            <div>수량: {curitem.qty}개</div>
          </div>
        </div>
      </div>
      {curitem.es_detail_total_price?
        <React.Fragment>
          <div className="flex vc fe font-bold" onClick={() => toggleDetail(i)}>
            {F.FormatNumber(curitem.es_detail_total_price)}원 <i ref={arrowRefs.current[i]}
                                                                className="fas fa-chevron-down"/>
          </div>
          <div ref={detailLayerRefs.current[i]} className="quote-item-detail flex dcol">
            <div className="flex jsb">
              <div>상품금액</div>
              <div> {F.FormatNumber(curitem.es_detail_prdct_price)}원</div>
            </div>
            <div className="flex jsb">
              <div>배송비</div>
              <div>
                {curitem.es_detail_dlvry_pay_type === '025202' && '착불배송비'}
                {curitem.es_detail_dlvry_fee > 0 ? (F.FormatNumber(curitem.es_detail_dlvry_fee) + '원') : '무료'}
              </div>
            </div>
            <div className="flex jsb">
              <div>할인금액</div>
              <div>{F.showAmount({
                amount: curitem.es_detail_dscnt_price,
                prefix: '-',
                color: '#fc1c67',
                falseVal: '-',
                unit: '원',
              })}</div>
            </div>
            <div className="flex jsb">
              <div>추가할인금액</div>
              <div>{F.showAmount({
                amount: curitem.es_detail_add_dscnt_price,
                prefix: '-',
                color: '#fc1c67',
                falseVal: '-',
                unit: '원',
              })}</div>
            </div>
          </div>
        </React.Fragment>
        :
        <div className="flex vc fe font-bold">
          {F.FormatNumber(curitem.es_prdct_price)}원
        </div>
      }
      {curitem.es_detail_prdct_desc &&
      <div className="seller-comment">
        {curitem.es_detail_prdct_desc}
      </div>}
    </MobileListBlock>
    )
  )

  const getItemsTableTr = (items)=>(
    items.map((curitem,i)=>
      <React.Fragment key={i}>
      <ListBlock>
        <td className="pt_title-box clearfix" colSpan={curitem.es_detail_total_price?"1":"2"}>
          <div className="product-thumbnail f-left pointer" onClick={()=>goToProduct(curitem.prdct_id)}>
            <div className="ed-front">
              <img className="product-img" src={curitem.repr_img} alt=""/>
            </div>
            <div className="ed-back">
              <a href="#"><span>{getCateName(curitem.cate_name)}</span></a>
            </div>
          </div>
          <div className="product-title f-left">
            <p className="pt-title pointer" onClick={()=>goToProduct(curitem.prdct_id)} >
              <a href="#">{curitem.prdct_nm}</a>
            </p>
            <div className="pt-option pointer" onClick={()=>goToProduct(curitem.prdct_id)} >
              <p><span>{curitem.opt_nm}</span></p>
              <p>수량 : <span>{curitem.qty}</span>개</p>
            </div>
          </div>
        </td>
        {/* 수량 - 견적전에만 표시 */}
        {!curitem.es_detail_total_price&&
        <td className="text_center">
          {F.showAmount({
            fontSize: "14px",
            amount: curitem.qty,
            weight: "700",
            unit:""
          })}
        </td>
        }
        {/* 상품금액 */}
        <td className="text_center">
          {getDscntPercent(curitem)}
          {F.showAmount({
            fontSize: curitem.es_detail_total_price?"14px":"20px",
            amount: curitem.es_detail_prdct_price,
            unit: '원',
            weight: curitem.es_detail_total_price?"400":"700",
          })}
        </td>
        {curitem.es_detail_total_price&&
        <>
          {/* 할인금액 */}
          <td className="text_center">
            {F.showAmount({
              fontSize: "14px",
              amount: curitem.es_detail_dscnt_price,
              prefix: '-',
              color: '#fc1c67',
              falseVal: '-',
              unit: '원',
              wrapper: curitem.es_detail_add_dscnt_price?"sale_plus":""
            })}
            {curitem.es_detail_add_dscnt_price>0&&
            <React.Fragment>
              <div className="fontsize-14 pink">추가 할인</div>
              {F.showAmount({
                fontSize: "14px",
                amount: curitem.es_detail_add_dscnt_price,
                prefix: '-',
                color: '#fc1c67',
                // falseVal: '-',
                unit: '원',
              })}
            </React.Fragment>
            }
          </td>
          {/* 배송비 */}
          <td className="text_center">
            <div style={isCashOnDlvryShow(curitem)}>
              {curitem.es_detail_dlvry_pay_type === '025202'&&
              <p className="fontsize-14 gray-text">착불 배송비</p>}
            </div>
            {F.showAmount({
              fontSize: "14px",
              amount: curitem.es_detail_dlvry_fee,
              unit: '원',
              falseVal: "무료"
            })}
          </td>
          {/* 견적금액 */}
          <td className="text_center">
            <p className="pt-pay"><span className="font-mont">
                    {F.FormatNumber(curitem.es_detail_total_price)}</span>원</p>
          </td>
        </>
        }
      </ListBlock>
      {curitem.es_detail_prdct_desc &&
      <ListBlock>
        <td colSpan="5" className="gray border_t-none thumb_none padding_none">
          {curitem.es_detail_prdct_desc.substr(0, 27)}
        </td>
      </ListBlock>
      }
    </React.Fragment>
    )
  )

  return (
    isMobileOnly?
    <ListContainerBlock>
      {getItemsMobile(props.items)}
    </ListContainerBlock>
      :
      <React.Fragment>
        {getItemsTableTr(props.items)}
      </React.Fragment>
  )
};

export default EsComItemList;
